import React from "react";
import PropTypes from "prop-types";
import { Player, BigPlayButton } from "video-react";
import "../../../node_modules/video-react/dist/video-react.css";
import "./styles.css";

export class Video extends React.Component {
  static propTypes = {
    source: PropTypes.string,
    videoNotFound: PropTypes.bool,
    thumbnail: PropTypes.string,
    onError: PropTypes.func,
    onEnded: PropTypes.func,
    className: PropTypes.string,
    autoPlay: PropTypes.bool,
    muted: PropTypes.bool,
    fluid: PropTypes.bool,
    loading: PropTypes.bool,
    loadingMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    maxRetries: PropTypes.number,
  };

  static defaultProps = {
    source: "",
    videoNotFound: false,
    thumbnail: "",
    className: "",
    autoPlay: false,
    muted: false,
    fluid: true,
    maxRetries: 5,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      reloading: true,
      retriesDone: 1,
      retryTimeout: 1000,
    };

    this.videoPlayer = React.createRef();
  }

  handleError = () => {
    const { onError, source } = this.props;
    if (onError) {
      onError();
      return;
    }

    const { maxRetries } = this.props;
    const { retriesDone, retryTimeout } = this.state;

    if (retriesDone <= maxRetries) {
      setTimeout(() => {
        this.videoPlayer.current && this.videoPlayer.current.load(`${source}#t=0.1`);
        this.setState({ retriesDone: retriesDone + 1 });
      }, retryTimeout * (retriesDone / 2));
    } else {
      this.setState({ error: true });
    }
  };

  handleCanPlay = () => {
    this.setState({ reloading: false, error: false });
  };

  handleReloadVideo = () => {
    const { source } = this.props;
    const { retryTimeout } = this.state;

    if (source) {
      this.setState({ reloading: true, error: false });
      setTimeout(() => {
        this.videoPlayer.current.load(`${source}#t=0.1`);
        this.setState({ retriesDone: 1 });
      }, retryTimeout);
    }
  };

  render() {
    const { error, reloading } = this.state;
    const {
      source,
      videoNotFound,
      thumbnail,
      className,
      autoPlay,
      muted,
      fluid,
      loading,
      loadingMessage,
      errorMessage,
      onEnded,
    } = this.props;
    const showLoading =
      loading || reloading || (!source && !error && !videoNotFound);

    const hasError = error || videoNotFound;

    return (
      <section className={`video-content ${className}`}>
        {hasError && (
          <div className="video-content-error">
            <span>
              {errorMessage || "Video not found"}
            </span>
            {!!source && (
              <i
                className="refresh icon big"
                onClick={this.handleReloadVideo}
              />
            )}
          </div>
        )}

        {source && (
          <Player
            ref={this.videoPlayer}
            className={hasError ? 'hidden' : undefined}
            src={`${source}#t=0.1`}
            poster={thumbnail}
            onCanPlay={this.handleCanPlay}
            onEnded={onEnded}
            onError={this.handleError}
            autoPlay={autoPlay}
            muted={muted}
            playsInline
            aspectRatio={'auto'}
            fluid={fluid}
          >
            <BigPlayButton position="center" />
          </Player>
        )}

        {!hasError && showLoading && (
          <div className="video-content-loader">
            {loadingMessage}
          </div>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Video/Video.jsx